<div mat-dialog-title>
  <h1 class="dialog-title" l10nTranslate>core.help</h1>
  <div class="title-actions">
    <mat-icon class="dialog__close" aria-hidden="false" aria-label="Close icon" (click)="onClose('close')">
      close
    </mat-icon>
  </div>
</div>
<div mat-dialog-content>
  <div class="info">
    <p l10nTranslate>
      <span class="bold" l10nTranslate>core.marketiqSupport</span>
      core.marketiqSupportDesc
    </p>
  </div>
  <div class="custom-tabs">
    <div class="bottomline-menu">
      <mat-card-content>
        <mat-tab-group (selectedIndexChange)="selectedIndexChange($event)" [selectedIndex]="tabIndex">
          <mat-tab [label]="'core.faq' | xTranslate">
            <ng-template matTabContent>
              <div class="faq-content">
                <miq-faq-list
                  [userInfo]="userInfo"
                  [pageId]="pageId$ | async"
                  [userId]="userInfo.id"
                  [email]="userInfo.emailAddress"
                ></miq-faq-list>
              </div>
            </ng-template>
          </mat-tab>
          <mat-tab [label]="'core.createServiceTicket' | xTranslate">
            <ng-template matTabContent>
              <miq-create-service-ticket
                [canvas]="canvas"
                [userInfo]="userInfo"
                [pageId]="pageId$ | async"
                [ticket]="ticket"
                (closeDialogBox)="onClose($event)"
              >
              </miq-create-service-ticket>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </mat-card-content>
    </div>
  </div>
</div>
